import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { checkCategoryProperties } from 'redux/product'
import { Divider, Grid, Header } from 'semantic-ui-react'
import ProductCategorySelector from './ProductCategorySelector'
import ProductCoreData from './ProductCoreData'
import ProductKeywordsDescription from './ProductKeywordsDescription'
import ProductStatus from './ProductStatus'
import ProductCopy from './ProductCopy'

const i18nkey = 'admin.product.generic.'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      checkCategoryProperties,
    },
    dispatch
  )
}

class ProductGeneric extends React.Component {
  render() {
    // actions
    const { checkCategoryProperties } = this.props

    // inherited props + actions
    const { form, product, compareProduct, keywords } = this.props
    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={form === 'product_import_form' ? 8: 12 }>
            <ProductStatus archived={product.status === 'archived'}/>
          </Grid.Column>
          {form === 'product_import_form' && (
            <Grid.Column width={4}>
              <ProductCopy />
            </Grid.Column>
          )}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12}>
            <ProductCategorySelector
              onChange={(event, newValue) => {
                checkCategoryProperties(form, newValue)
              }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={6}>
            {product.product_family && (
              <div>
                <Header
                  as="h3"
                  dividing
                  content={I18n.t(i18nkey + 'pareny_family')}
                />
                {product.product_family.title}
                <Divider />
              </div>
            )}
            <ProductCoreData
              product={product}
              compareProduct={compareProduct}
            />
          </Grid.Column>

          <Grid.Column width={6}>
            <ProductKeywordsDescription suggestions={keywords} form={form} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

ProductGeneric = connect(mapStateToProps, mapDispatchToProps)(ProductGeneric)
export default ProductGeneric



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductGeneric.jsx